import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { FIELD_ERRORS } from './messages.constant';

export const VALIDATORS = {
  // Static
  required: RxwebValidators.required(),

  // Dynamic
  maxLength: (value?: number) => RxwebValidators.maxLength({ value: value || 255, message: FIELD_ERRORS.maxLength }),
}